import { render, staticRenderFns } from "./watch-video.vue?vue&type=template&id=0f2f1685&"
import script from "./watch-video.js?vue&type=script&lang=js&"
export * from "./watch-video.js?vue&type=script&lang=js&"
import style0 from "./watch-video.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports